/**
 * Registry dei nomi evento introdotti dal 2026-07-22 in poi.
 *
 * Regole (vedi Product/Analytics/EVENTI-PRODOTTO.md):
 * - gli eventi storici restano stringhe/helper in analytics.js e NON si rinominano
 *   (spezzerebbe le serie storiche GA4);
 * - ogni costante aggiunta qui = una riga nel bacino giusto di EVENTI-PRODOTTO.md
 *   nello stesso commit;
 * - naming: snake_case, max 40 char, schema {bacino/feature}_{azione}_{oggetto}.
 */
export const ANALYTICS_EVENTS = {
  // Bacino: Progressi
  PROGRESSI_PAGE_VIEWED: 'progressi_page_viewed',
  PERFORMANCE_CHART_RANGE_CHANGED: 'performance_chart_range_changed',

  // Bacino: Documenti / Materiali
  MATERIALS_PAGE_VIEWED: 'materials_page_viewed',
  MATERIAL_DOCUMENT_OPENED: 'material_document_opened',

  // Bacino: Esami Orali — conversazione vocale
  VOICE_EXAM_STARTED: 'voice_exam_started',
  VOICE_TURN_COMPLETED: 'voice_turn_completed',
  VOICE_EXAM_COMPLETED: 'voice_exam_completed',
  // Studia insieme (STU-307): la videocamera dello studente accesa o spenta a mano
  TUTOR_CAMERA_TOGGLED: 'tutor_camera_toggled',

  // Bacino: Esami Orali — ripasso mirato sugli errori (STU-91)
  // Proprietà: `wrong_count` = domande andate male, ed è IL NUMERO MOSTRATO
  // all'utente; `filler_count` = domande già superate mescolate al ripasso come
  // gruppo di controllo (~25%). Le domande somministrate sono la SOMMA dei due:
  // contarle con `wrong_count` dà un numero sbagliato senza dare errore.
  // Il rapporto e il perché del controllo: `utils/wrongQuestions.js` §FILLER_RATIO.
  WRONG_SIMULATION_OFFERED: 'wrong_simulation_offered',
  WRONG_SIMULATION_STARTED: 'wrong_simulation_started',

  // Bacino: Home — "Il piano di oggi" (TodayDeck)
  // I tre nomi sotto esistono in produzione dal 11/08 e NON si rinominano.
  // Cambia invece la semantica di `deck_card_shown`: dall'11/08 fira UNA volta
  // al giorno per utente (parametro `deck_day`), non una per montaggio del
  // componente. Prima il denominatore contava le aperture della home, quindi il
  // tasso di accettazione usciva diviso per il numero di navigazioni: le poche
  // ore di serie precedenti non sono confrontabili con quelle successive.
  // Il tasso va letto PER `card_type`: "recupero" chiede di rifare un esame, e
  // il base rate storico di quel gesto e' ~1,00 esami per coppia studente-documento.
  DECK_CARD_SHOWN: 'deck_card_shown',
  DECK_CARD_CLICKED: 'deck_card_clicked',
  DECK_CARD_SKIPPED: 'deck_card_skipped',
  DECK_DAY_COMPLETED: 'deck_day_completed',
  DECK_PROGRESS_OPENED: 'deck_progress_opened',

  // Bacino: Navigazione (shell)
  // Fino al 14/08 l'UNICA voce di nav strumentata era il calendario, per un
  // evento storico ereditato: tutte le altre passavano in silenzio, in
  // entrambe le shell. Il parametro che conta e' `item_id` — il conteggio per
  // nome evento, da solo, non dice quale voce e' stata cliccata e va letto in
  // BigQuery, non dall'endpoint /ga4-events (che non fa breakdown per parametro).
  SIDEBAR_NAV_CLICK: 'sidebar_nav_click',

  // Trasversale: blocchi di attivazione (STU-520). Si mandano SOLO con
  // `tracciaBlocco` di analytics.js, che aggiunge `blocco`, `variante`, `passo`
  // e `dettaglio`. La mappa dei blocchi: config/blocchi.js.
  BLOCCO_VISTO: 'blocco_visto',
  BLOCCO_AZIONE: 'blocco_azione',
  BLOCCO_CHIUSO: 'blocco_chiuso',
};

export default ANALYTICS_EVENTS;
